import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  ITINERARY_CHANGE_ROUTE_PATH,
  NEW_ITINERARY_CHANGE_ROUTE_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { ITINERARY_CHANGE_ROUTE_COLUMNS } from '../../../../config/columns';
import {
  clearItineraryChangeRoutes,
  getItineraryChangeRoutes,
} from '../../../../actions/itinerary/ItineraryChangeRoute';

export const Activities = ({
  breadcrumbs,
  itineraryChangeRoute,
  loading,
  dispatchGetItineraryChangeRoutes,
  dispatchClearItineraryChangeRoutes,
}) => {
  useLayoutEffect(() => () => dispatchClearItineraryChangeRoutes(), []);

  const data = itineraryChangeRoute.get('content') || [];
  const pages = itineraryChangeRoute.get('totalPages') || null;
  const defaultPageSize = itineraryChangeRoute.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Cambios de Ruta en Itinerarios"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_ITINERARY_CHANGE_ROUTE_PATH}
      tableStructure={{
        columns: ITINERARY_CHANGE_ROUTE_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetItineraryChangeRoutes,
        modelPath: ITINERARY_CHANGE_ROUTE_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetItineraryChangeRoutes: getItineraryChangeRoutes,
  dispatchClearItineraryChangeRoutes: clearItineraryChangeRoutes,
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  breadcrumbs: [
    ...ItineraryUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Cambios de Ruta en Itinerarios ',
      href: ITINERARY_CHANGE_ROUTE_PATH,
    },
  ],
  itineraryChangeRoute: ItineraryUnit.ItineraryChangeRoute.getIn([
    'all',
    'content',
  ]),
  loading: ItineraryUnit.ItineraryChangeRoute.getIn(['all', 'loading']),
});

Activities.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  itineraryChangeRoute: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetItineraryChangeRoutes: PropTypes.func.isRequired,
  dispatchClearItineraryChangeRoutes: PropTypes.func.isRequired,
};

Activities.defaultProps = {
  itineraryChangeRoute: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Activities);
